import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { TransactionDescriptionService } from 'app/services/models/transaction-description.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class ListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  totalCount: Number = 0;
  kindId: number;
  public ColumnMode = ColumnMode;

  constructor(private transactionDescriptionService:TransactionDescriptionService) { }

  async ngOnInit() {

    await this.getAllTransactionDescription(this.pageBasic - 1, this.selectedSize);

  }
  async getAllTransactionDescription(page,size){
    const data = await this.transactionDescriptionService.getAllTransactionDescriptionList(page,size);
    console.log(data);
    this.rows = data.transactionManagemetnDescriptions;
    this.totalCount = data.totalCount;
  }
}
